import React from "react";
import { Helmet } from "react-helmet";
const MobappHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Mobile App Development Company In USA
      </title>
      <meta
        name="description"
        content="Leading mobile app development company in USA delivering innovative Android, iOS, and mobile app design solutions that boost growth and engagement."
      />
    </Helmet>
  );
};

export default MobappHelmet;
